// Currently no Footer is used.
const Footer = () => null

export default Footer
